module.exports = __webpack_public_path__ + "static/media/PG_logo.55645e26.svg";